// extracted by mini-css-extract-plugin
export default {"SideBar":"SideBar_SideBar__f2a6k","List":"SideBar_List__iGRUv"};